import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  .component_connect_steps {
    margin: 24px 0;
    padding-bottom: 24px;
    border-bottom: 4px solid ${color.grey1};
    display: flex;
    align-items: center;
    column-gap: 12px;
    position: relative;
    ::before {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 0;
      background-color: ${color.orange1};
      height: 4px;
      width: ${(props) => {
        return `${(100 / props?.totalSteps) * props?.currentStep}%`;
      }};
      transition: 0.5s ease;
      z-index: 1;
    }
  }

  .component_connect_steps_control {
    border-top: 1px solid ${color.grey1};
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    padding-top: 24px;
  }
`;

export default Wrapper;
